import { Injectable } from "@angular/core";
import { MergeModel } from "../models/MergeModel";
import { MultiLanguageService } from "projects/lib/medcare-core-lib/src/lib/core/multi-language/multi-language.service";
import { PatientService } from "projects/lib/medcare-core-lib/src/lib/services/patient.service";

@Injectable()
export class MergePatientService {
  list: any = [];
  constructor( private patientService: PatientService,
    private langService: MultiLanguageService) {}

  /**
   *Merge Model
   *
   * @param {*} merger
   * @return {*}  {MergeModel}
   * @memberof MergePatientService
   */
  patientMergeModel(merger: any): MergeModel {
    const alldata = new MergeModel();
    alldata.Id = merger.id,
    alldata.primaryIDdesc = merger.identifierType ? merger.identifierType : "",
    alldata.primaryId= merger.idNo ? merger.idNo : "",
    alldata.firstName= merger.fullName,
    alldata.dob= merger.dateOfBirth ? merger.dateOfBirth : "",
    alldata.phoneNumber= merger.mobileNumber ? merger.mobileNumber : "",
    alldata.countryCode =merger.countryCode ? merger.countryCode : "",
    alldata.mrn= merger.mrn,
    alldata.gender= merger.gender ? merger.gender : "";
    return alldata;
  }
  
  /**
   *Modele List
   *
   * @param {*} mergeList
   * @return {*}  {MergeModel}
   * @memberof MergePatientService
   */
  patientMergeList(mergeList: any): MergeModel {
    try {
      let list: any = [];
      mergeList.forEach((element) => {
        if(element.merged.status==true){
        let primaryGender = element.primaryPatientDetails ? 
        (element.primaryPatientDetails.gender ? element.primaryPatientDetails.gender.display : "") 
        : "";      
        let seondaryGender=element.gender ? element.gender.display : "";
        let secondaryDob:any=element.birthDate ?this.patientService.calculateAge(element.birthDate) : ""
        let primaryDob:any=element.primaryPatientDetails.birthDate ?this.patientService.calculateAge(element.primaryPatientDetails.birthDate) : ""
   
        const secondaryDetails = [
          element.patientName ? element.patientName : "",
          seondaryGender,
          secondaryDob ? `${secondaryDob.years} ${secondaryDob.months} ${secondaryDob.days}` : ""
        ].filter(val => val).join(' / ');
        
        const primaryDetails = [
          element.primaryPatientDetails ? element.primaryPatientDetails.patientName : "",
          primaryGender, 
          primaryDob ? `${primaryDob.years}, ${primaryDob.months}, ${primaryDob.days}` : ""
        ].filter(val => val).join(' / ');

        const blockModel: MergeModel = {
          Id: element.id,
          primaryMrn: element.merged ? element.merged.primaryMrn : "",
          primaryGender : primaryGender ? primaryGender :"",
          firstName:element.primaryPatientDetails ? element.primaryPatientDetails.patientName : "",
          firstAge: primaryDob ? `${primaryDob.years}, ${primaryDob.months}, ${primaryDob.days}` : "",
          primaryDob : element.primaryPatientDetails ? element.primaryPatientDetails.birthDate :"",

          seondaryGender : seondaryGender,
          secondaryMrn: element.mrn ? element.mrn : "",
          secondaryPatientDetails: secondaryDetails,
          secondName:element.patientName ? element.patientName : "",
          secondaryDob:element.birthDate ? element.birthDate : "",
          secondAge:secondaryDob ? `${secondaryDob.years}, ${secondaryDob.months}, ${secondaryDob.days}` : "",
  
          mergedBy: element.merged ? element.merged.mergedBy : "",
          mergedOn: element.merged ?this.patientService.epochToDateConverter(element.merged.mergedOn*1000) : "",
          mergedReason:element.merged?(element.merged.reason?element.merged.reason[0].display:""):"",
          mergedRemarks:element.merged?(element.merged.remarks?element.merged.remarks:""):"",
          unMergedBy: element.unmerged ? element.unmerged.unMergedBy : "",
          unMergedOn: element.unmerged ? this.patientService.epochToDateConverter(element.unmerged.unMergedOn*1000): "",
          unMergedReason:element.unmerged?(element.unmerged.reason?element.unmerged.reason[0].display:""):"",
          unMergedRemarks:element.unmerged?(element.unmerged.remarks?element.unmerged.remarks:""):"",
          status: element.merged.status == true ? "Merged" : "Merged",
        };
        list.push(blockModel);
      }
    });
      return list;
    } catch (ex) {}
  }
  patientMergeUnmergedList(patientMergeUnmergedList: any): MergeModel {
    try {
      let list: any = [];
      patientMergeUnmergedList.forEach((element) => {
         let primaryGender = element.primaryGender ? element.primaryGender.desc : "";
        let secondaryGender = element.secondaryGender ? element.secondaryGender.desc : "";
        let primaryDob: any = element.primaryDob ? this.patientService.calculateAge(element.primaryDob) : "";
        let secondaryDob: any = element.secondaryDob ? this.patientService.calculateAge(element.secondaryDob) : "";

const primaryDetails = [
  element.primaryName ? element.primaryName : "",
  primaryGender,
  primaryDob ? `${primaryDob.years} ${primaryDob.months} ${primaryDob.days}` : ""
].filter(val => val).join(' / ');

const secondaryDetails = [
  element.secondaryPatientName ? element.secondaryPatientName : "",
  secondaryGender
].filter(val => val).join(' / ');

const blockModel: MergeModel = {
  Id: element.id,

          primaryMrn:  element.primaryMrn ? element.primaryMrn : "",
          primaryGender : element.primaryGender ? element.primaryGender.desc : "",
          firstName: element.primaryName ? element.primaryName : "",
          firstAge:  primaryDob ? `${primaryDob.years}, ${primaryDob.months}, ${primaryDob.days}` : "",
          primaryDob : element.primaryDob ? element.primaryDob :"",

          seondaryGender : element.secondaryGender ? element.secondaryGender.desc : "",
          secondaryMrn: element.secondaryMrn ? element.secondaryMrn : "",
          secondName: element.secondaryPatientName ? element.secondaryPatientName : "",
          secondaryDob:element.secondaryDob ? element.secondaryDob : "",
          secondAge:secondaryDob ? `${secondaryDob.years}, ${secondaryDob.months}, ${secondaryDob.days}` : "",
  // primaryMrn: element.primaryMrn ? element.primaryMrn : "",
  // secondaryMrn: element.secondaryMrn ? element.secondaryMrn : "",
  primaryPatientDetails: primaryDetails,
  secondaryPatientDetails: secondaryDetails,
  performedBy: element.performedBy ? element.performedBy : "",
  performedOn: element.performedOn ? this.patientService.epochToDateConverter(element.performedOn * 1000) : "",
  reason: element.reason ? element.reason.desc : "",
  remarks: element.remarks ? element.remarks : "",
  unMergedBy: element.unmerged ? element.unmerged.unMergedBy : "",
  unMergedOn: element.unmerged ? this.patientService.epochToDateConverter(element.unmerged.unMergedOn * 1000) : "",
  status: element.status ? element.status : ""
};
        list.push(blockModel);
      });
      return list;
    } catch (ex) {}
  }
}
